module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('PRO_EXTERNAL_DOCUMENTATION'),
      "hide-details": "",
      "color": "main-color"
    },
    model: {
      value: (_vm.examinationData.pro_external_documentation),
      callback: function($$v) {
        _vm.$set(_vm.examinationData, "pro_external_documentation", $$v)
      },
      expression: "examinationData.pro_external_documentation"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "w160 app-btn app-btn--small app-btn-primary",
    attrs: {
      "disabled": !_vm.examinationData.pro_external_documentation
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendExaminationData.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('CLOSE')) + "\n        ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-683dc7e2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/medical-results/external-documentation-data-form.vue
// module id = 1216
// module chunks = 0